import "./AboutContentStyle.css";
import React from 'react';
import { Link } from "react-router-dom";
import team1 from '../assets/team1.jpg';
import team2 from '../assets/team2.jpeg';
import team3 from '../assets/team3.jpg';


const AboutContent = () => {
  return (
    <div className="about">

      <div className="left">
        <h1>מי אנחנו</h1>
        <p>
          בעידן שבו הכל נשלט מהנייד, למה שהמים יהיו שונים?
          הכירו את הפתרון החדשני שלנו המאפשר לכם לסגור ולפתוח מגופים ישירות מהנייד.
        </p>
        <p>
          המגופים ותשתיות השליטה שלנו מספקים מספר יתרונות <br/>
           טיפול מהיר בתקלות - <br/>
           מזעור תקלות כבר בשלב הראשוני - <br/>
           שירות מהימן ואמין לתושבים - <br/>
           שליטה במגופים רבים בו זמנית ללא צורך בצוותים שידלגו ממקום למקום - <br/>
           פתרון מהיר במצבי חירום - <br/>
        </p>
      </div>

      <div className="team">
        <div className="team-member">
          <img src={team1} alt="נועם כהן" />
          <h3>נועם כהן</h3>
          <p>CTO — מומחה לפתרונות בקרה חכמים ומערכות IoT</p>
        </div>
        <div className="team-member">
          <img src={team2} alt="טל לוי" />
          <h3>טל לוי</h3>
          <p>מהנדס ראשי — מוביל התקנות ותשתיות מקומיות</p>
        </div>
        <div className="team-member">
          <img src={team3} alt="רוני ברק" />
          <h3>רוני ברק</h3>
          <p> מנהל פרויקט - מקשר בין הצוות ללקוחות</p>
        </div>
      </div>

      <div className="button-wrap">
        <Link to="/contact">
          <button className="btn">צרו קשר</button>
        </Link>
      </div>

    </div>
  );
};

export default AboutContent;
